import {
  Button,
  Dialog,
  DialogContent,
  MenuItem,
  TextField,
  Typography,
  withWidth,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getWarehouses,
  paymentStates,
} from "../../Utils/Common";

import SpeakerPhoneIcon from "@material-ui/icons/SpeakerPhone";
import { useDispatch } from "react-redux";
import SortableTable from "../../Components/SortableTable";
import Title from "../../Components/Title";
import GraphDialog from "./EditStockItemDialog/GraphDialog";
import QRGeneratorView from "./QRGeneratorView";
import QRScannerView from "./QRScannerView";

function WarehouseTab({
  selectedWarehouse,
  setEditedValues,
  setSelectedWarehouse,
  editedValues,
  edit,
  stockChanges,
  otherWarehouses,
  onlyEditableWarehouses,
  newItem,
  width,
}) {
  const { t } = useTranslation();
  const [showStockTable, setShowStockTable] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [showQRGenerator, setShowQRGenerator] = useState(false);
  const [scannedCode, setScannedCode] = useState();
  const [warehouseLocation, setWarehouseLocation] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (scannedCode) {
      setEditedValues({
        ...editedValues,
        scannerCode: scannedCode,
      });
      setScannedCode();
    }
  }, [scannedCode]);

  useEffect(() => {
    getWarehouses(setWarehouseLocation, dispatch);
  }, [dispatch]);

  const getScannerCodeval = (editedValues, edit, newItem) => {
    if (newItem) {
      return editedValues?.scannerCode !== editedValues?.sku
        ? editedValues.scannerCode
        : null;
    }
    if (editedValues?.scannerCode) {
      return editedValues.scannerCode !== edit?.StockItem.sku
        ? editedValues.scannerCode
        : null;
    }
    return edit.scannerCode !== edit?.StockItem.sku ? edit.scannerCode : null;
  };

  return warehouseLocation ? (
    <Grid container spacing={1}>
      <Dialog
        open={showQRGenerator}
        onClose={() => {
          setShowQRGenerator(false);
        }}
      >
        <DialogContent style={{ minWidth: 350 }}>
          <QRGeneratorView
            value={
              editedValues?.scannerCode ||
              edit?.scannerCode ||
              edit?.StockItem?.sku
            }
            labeldata={{
              scannerCode: getScannerCodeval(editedValues, edit, newItem),
              sku: editedValues?.sku || edit?.StockItem?.sku || edit?.sku,
              name: editedValues?.name || edit?.StockItem.name || edit?.name,
              shelf:
                editedValues?.shelf || edit?.StockItem.shelf || edit?.shelf,
            }}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={showQRScanner} fullScreen={width === "xs"}>
        <DialogContent>
          <QRScannerView
            width={width}
            show={showQRScanner}
            exit={() => {
              setShowQRScanner(false);
            }}
            setValue={setScannedCode}
          ></QRScannerView>
        </DialogContent>
      </Dialog>
      {!selectedWarehouse ||
      warehouseLocation.find((f) => f.value === selectedWarehouse)
        ?.editableStock ? (
        <></>
      ) : (
        <Grid item xs={12}>
          <Typography>{t("stockModule.thirdPartyStock")}</Typography>
        </Grid>
      )}
      <Grid
        item
        container
        xs={12}
        sm={6}
        direction="row"
        alignItems="flex-start"
        alignContent="flex-start"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            variant="outlined"
            label={t("stockModule.warehouse")}
            defaultValue={selectedWarehouse}
            onChange={(e, v) => {
              if (!e || !e.target.value) {
                return;
              }
              setSelectedWarehouse(e.target.value);
              var obj = { ...editedValues };
              if (obj.total) {
                delete obj.total;
              }
              if (obj.alertQuantity) {
                delete obj.alertQuantity;
              }
              if (obj.free) {
                delete obj.free;
              }
              if (obj.unit) {
                delete obj.unit;
              }
              if (obj.shelf) {
                delete obj.shelf;
              }
              if (obj.scannerCode) {
                delete obj.scannerCode;
              }
              setEditedValues({
                ...obj,
                warehouse: e.target.value,
              });
            }}
            select
          >
            {warehouseLocation
              .filter((f) => (onlyEditableWarehouses ? f.editableStock : f))
              .map((m, i) => (
                <MenuItem key={m.value + i} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        {!warehouseLocation.find((f) => f.value === selectedWarehouse)
          ?.editableStock ? (
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              inputProps={{ min: 0 }}
              key={selectedWarehouse + "f"}
              disabled={true}
              label={t("stockModule.free")}
              defaultValue={
                newItem
                  ? ""
                  : selectedWarehouse &&
                    edit &&
                    selectedWarehouse === edit?.Warehouse.name
                  ? edit.free
                  : (otherWarehouses &&
                      otherWarehouses.find(
                        (o) =>
                          o.StockItem.id === edit.StockItem.id &&
                          o.Warehouse.name === selectedWarehouse
                      )?.free) ||
                    0
              }
              onChange={(e, v) => {
                setEditedValues({
                  ...editedValues,
                  free: e.target.value,
                });
              }}
              value={editedValues?.free}
            ></TextField>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            key={selectedWarehouse + "t"}
            disabled={
              !warehouseLocation.find((f) => f.value === selectedWarehouse)
                ?.editableStock
            }
            defaultValue={
              newItem
                ? ""
                : selectedWarehouse &&
                  edit &&
                  selectedWarehouse === edit?.Warehouse.name
                ? edit.total
                : (otherWarehouses &&
                    otherWarehouses.find(
                      (o) =>
                        o.StockItem.id === edit.StockItem.id &&
                        o.Warehouse.name === selectedWarehouse
                    )?.total) ||
                  0
            }
            label={t("stockModule.total")}
            inputProps={{ min: 0 }}
            onChange={(e, v) => {
              var obj = { ...editedValues };
              if (
                warehouseLocation.find((f) => f.value === selectedWarehouse)
                  ?.editableStock
              ) {
                // Set both values
                obj.free = e.target.value;
              }
              obj.total = e.target.value;
              setEditedValues(obj);
            }}
            value={editedValues?.total}
          ></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            key={selectedWarehouse + "a"}
            label={t("stockModule.alertQuantity")}
            inputProps={{ min: 0 }}
            defaultValue={
              newItem
                ? ""
                : selectedWarehouse &&
                  edit &&
                  selectedWarehouse === edit?.Warehouse.name
                ? edit.alertQuantity
                : (otherWarehouses &&
                    otherWarehouses.find(
                      (o) =>
                        o.StockItem.id === edit.StockItem.id &&
                        o.Warehouse.name === selectedWarehouse
                    )?.alertQuantity) ||
                  0
            }
            onChange={(e, v) => {
              setEditedValues({
                ...editedValues,
                alertQuantity: e.target.value,
              });
            }}
            value={editedValues?.alertQuantity}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            key={selectedWarehouse + "u"}
            variant="outlined"
            label={t("stockModule.unitOfMeasurement")}
            style={{
              display: !warehouseLocation.find(
                (f) => f.value === selectedWarehouse
              )?.editableStock
                ? "none"
                : "",
            }}
            defaultValue={
              newItem
                ? ""
                : selectedWarehouse &&
                  edit &&
                  selectedWarehouse === edit?.Warehouse.name
                ? edit.unit
                : otherWarehouses &&
                  otherWarehouses.find(
                    (o) =>
                      o.StockItem.id === edit.StockItem.id &&
                      o.Warehouse.name === selectedWarehouse
                  )?.unit
            }
            onChange={(e, v) => {
              setEditedValues({
                ...editedValues,
                unit: e.target.value,
              });
            }}
            value={editedValues?.unit}
          ></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            key={selectedWarehouse + "shelf"}
            variant="outlined"
            label={t("stockModule.warehouseShelf")}
            style={{
              display: !warehouseLocation.find(
                (f) => f.value === selectedWarehouse
              )?.editableStock
                ? "none"
                : "",
            }}
            defaultValue={
              newItem
                ? ""
                : selectedWarehouse &&
                  edit &&
                  selectedWarehouse === edit?.Warehouse.name
                ? edit.shelf
                : otherWarehouses &&
                  otherWarehouses.find(
                    (o) =>
                      o.StockItem.id === edit.StockItem.id &&
                      o.Warehouse.name === selectedWarehouse
                  )?.shelf
            }
            onChange={(e, v) => {
              setEditedValues({
                ...editedValues,
                shelf: e.target.value,
              });
            }}
            value={editedValues?.shelf}
          ></TextField>
        </Grid>
        {warehouseLocation.find((f) => f.value === selectedWarehouse)
          ?.editableStock && (
          <Grid item container xs={12} justify="center" alignItems="center">
            <Grid item xs={12}>
              <TextField
                fullWidth
                disabled
                key={selectedWarehouse + "scanner"}
                variant="outlined"
                label={t("stockModule.scannerCode")}
                InputLabelProps={{
                  shrink: !!(editedValues?.scannerCode || scannedCode)
                    ? true
                    : undefined,
                }}
                style={{
                  display: !warehouseLocation.find(
                    (f) => f.value === selectedWarehouse
                  )?.editableStock
                    ? "none"
                    : "",
                }}
                defaultValue={
                  newItem
                    ? ""
                    : selectedWarehouse &&
                      edit &&
                      selectedWarehouse === edit?.Warehouse.name
                    ? edit.scannerCode
                    : otherWarehouses &&
                      otherWarehouses.find(
                        (o) =>
                          o.StockItem.id === edit.StockItem.id &&
                          o.Warehouse.name === selectedWarehouse
                      )?.scannerCode
                }
                value={editedValues?.scannerCode || scannedCode}
              ></TextField>
            </Grid>
            <Grid
              item
              container
              xs={12}
              alignContent="center"
              spacing={1}
              style={{ marginTop: 10 }}
            >
              <Grid item>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setShowQRScanner(true);
                  }}
                  style={{
                    display: !warehouseLocation.find(
                      (f) => f.value === selectedWarehouse
                    )?.editableStock
                      ? "none"
                      : "",
                  }}
                  endIcon={<SpeakerPhoneIcon />}
                >
                  {t("stockModule.scanExistingCode")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  onClick={() => {
                    if (newItem) {
                      setEditedValues({
                        ...editedValues,
                        scannerCode: editedValues?.sku,
                      });

                      return;
                    }
                    setEditedValues({
                      ...editedValues,
                      scannerCode: edit.StockItem.sku,
                    });
                  }}
                >
                  {t("stockModule.generateCode")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  fullWidth
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setShowQRGenerator(true);
                  }}
                >
                  {t("stockModule.showQRCodeLabel")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      {edit ? (
        <Grid item container xs={12} sm={6}>
          {stockChanges ? (
            <GraphDialog
              graphKey={selectedWarehouse + "g"}
              edit={
                selectedWarehouse &&
                edit &&
                selectedWarehouse === edit?.Warehouse.name
                  ? edit
                  : otherWarehouses &&
                    otherWarehouses.find(
                      (o) =>
                        o.StockItem.id === edit.StockItem.id &&
                        o.Warehouse.name === selectedWarehouse
                    )
              }
              _stockChanges={stockChanges}
              noDialog={true}
            />
          ) : (
            <Typography>{t("stockModule.noGraphsAvailable")}</Typography>
          )}
        </Grid>
      ) : null}
      {edit ? (
        <Grid
          container
          item
          xs={12}
          style={{ marginTop: 30, marginBottom: 50 }}
        >
          <Grid item xs={12} container direction="row">
            <Title>{t("stockModule.stockChangesTable")}</Title>
            <Button
              style={{ marginLeft: 20 }}
              variant="outlined"
              onClick={() => {
                setShowStockTable(!showStockTable);
              }}
            >
              {showStockTable ? t("hide") : t("show")} {t("table")}
            </Button>
          </Grid>
          <div
            style={{
              display: !showStockTable ? "none" : "",
              width: "100%",
            }}
          >
            <SortableTable
              header={t("stockModule.stockChanges")}
              downloadButton={true}
              headCells={[
                {
                  id: "updatedAt",
                  numeric: false,
                  disablePadding: false,
                  label: t("updatedAt"),
                },
                {
                  id: "free",
                  label: t("stockModule.free"),
                },
                {
                  id: "total",
                  label: t("stockModule.total"),
                  numeric: false,
                  disablePadding: false,
                },
                {
                  id: "events",
                  label: t("stockModule.events"),
                  numeric: false,
                  disablePadding: false,
                },
                {
                  id: "User.fullName",
                  numeric: false,
                  disablePadding: false,
                  label: t("createdBy"),
                },
              ]}
              // disablePagination: true,
              defaultSortRow={"updatedAt"}
              handleRowClick={() => {}}
              getRowStyle={(data) => {
                var obj = { cursor: "pointer" };
                var p = paymentStates.find(
                  (f) => data.paymentStatus === f.value
                );
                if (p && p.color) {
                  return { ...obj, backgroundColor: p.color };
                }
                return obj;
              }}
              specialDataFormatting={[
                {
                  id: "updatedAt",
                  format: (data, d, dd) => {
                    if (dd.Notes && dd.Notes.length) {
                      const max = dd.Notes.reduce((prev, current) =>
                        prev && prev.id > current.id ? prev : current
                      );
                      return formatTimeWithTZOffset(max.updatedAt, ECABIN);
                    }
                    return formatTimeWithTZOffset(data, ECABIN);
                  },
                },
                {
                  id: "events",
                  format: (data) => {
                    if (data) {
                      return data
                        .map((d) =>
                          Object.keys(d)
                            .map((m) => `${m}: ${d[m]}`)
                            .join(" ")
                        )
                        .join(" ");
                    }
                    return "";
                  },
                },
              ]}
              tableData={stockChanges}
              rowsPerPage={50}
            ></SortableTable>
          </div>
        </Grid>
      ) : null}
    </Grid>
  ) : null;
}

export default withWidth()(WarehouseTab);
